
import { AwsDocument } from "@/models/base/aws-document";
import { AWSFileService } from "@/services";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			downloading: false
		};
	},
	props: {
		doc: {
			type: Object as ()=>AwsDocument,
			required: true
		},
		documents: {
			type: Array as ()=>AwsDocument[],
			required: true,
		},
		toRemoveDocs: {
			type: Array as ()=>AwsDocument[],
			required: true
		},
		edit: Boolean,
		uploading: Boolean
	},
	computed: {
		downloadIcon():string {
			if (this.downloading) {
				return "sync";
			}
			return "download";
		}
	},
	methods: {
		async download(){
			if (this.downloading) return;
			this.downloading = true;
			try{
				if (!this.doc.File) return;
				await AWSFileService.saveFile(this.doc.File);
			}catch(err){

			}finally{
				this.downloading = false;
			}
		},
		deleteDocument(){
			let i = this.documents.indexOf(this.doc);
			if (i == -1) return;
			this.toRemoveDocs.push(this.doc);
			this.documents.splice(i,1);
		},
		open(){
			if (!this.doc.File) return;
			let url = this.doc.File.getUrl();
			window.open(url, "_blank");
		}
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});

